import fetch from "auth/FetchInterceptor";
import i18n from "i18next";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: `${process.env.REACT_APP_API_URL}/signin`,
    method: "post",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
      "accept-language": i18n.language,
    },
    data: data,
  });
};

AuthService.logout = function () {
  return fetch({
    url: `${process.env.REACT_APP_API_URL}/signout`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      "accept-language": i18n.language,
    },
  });
};

AuthService.register = function (data) {
  return fetch({
    url: `${process.env.REACT_APP_API_URL}/auth/signup`,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
      "accept-language": i18n.language,
    },
  });
};

export default AuthService;
